// extracted by mini-css-extract-plugin
module.exports = {"ErrorBoundary":"styles_ErrorBoundary__37b8l"};